import { validator } from "LIB/validate-this";
import { DISCREPANCY_TYPE } from "MODULES/Receiving/constants";

function validateItem(item) {
  item.validate(DISCREPANCY_TYPE).required();
}

export default function validate(values) {
  return validator(values, form => {
    form.validateChildren("discrepancies", validateItem);
  });
}



// WEBPACK FOOTER //
// ./app/modules/Receiving/Detail/Discrepancies/validate.js